





















































































import * as fb from '@/firebase';
import * as store from '@/store';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { UserProfile } from '@/models/user-profile';
import moment from 'moment';
import { UserModule, UserStore } from '@/store/modules/user';
import { UserFollowActions } from '@/actions/user-follow-actions';
import { UserProfileUtil } from '@/model-utils/user-profile-util';
import ListCard from '@/components/list-cards/ListCard.vue';
import { ListModel } from '@/models/list-model';
import { ListModelUtil } from '@/model-utils/list-model-util';
import UserFollowWidget from '@/components/UserFollowWidget.vue'
import UserAvatar from '@/components/UserAvatar.vue';

const numeral = require('numeraljs');

@Component({
  components: { ListCard, UserFollowWidget, UserAvatar }
})
export default class ProfileView extends Vue {
  @Prop(UserProfile) public readonly _userProfile!: UserProfile;

  public userProfile: UserProfile = null;

  public error: boolean = false;
  @Prop(String) private username?: string;

  public lists: ListModel[] = [];

  public mounted() {
    this.fetchUserProfile();
    this.tryLoadLists();
  }

  public fetchUserProfile() {
    if (this.username) {
      return UserProfileUtil.fetchProfileByUsername(this.username).then(
        this.setUserProfile
      );
    } else {
      if (UserModule.userProfile) {
        this.setUserProfile(UserModule.userProfile);
      } else {
        throw new Error('profile unspecified');
      }
    }
  }

  private joined(userProfile: UserProfile) {
    return moment(userProfile.joinDate, 'YYYYMMDD').fromNow();
  }

  get isMyProfile(): boolean {
    return !!this.userProfile && this.userProfile.id === UserModule.currentUserId;
  }

  async setUserProfile(userProfile: UserProfile) {
    this.userProfile = userProfile;
    this.setMetaTags();
  }

  get numFollowers() {
    return numeral(this.userProfile.numFollowers).format('0a');
  }

  get numFollowing() {
    return numeral(this.userProfile.numFollowing).format('0a');
  }

  get isAdmin() {
    return UserModule.userProfile && UserModule.userProfile.isAdmin;
  }

  setIsAdmin() {
    UserProfileUtil.setIsAdmin(this.userProfile.id, !this.userProfile.isAdmin);
  }

  tryLoadLists() {
    if (this.isMyProfile) {
      ListModelUtil.watchAllListsByUsername({
        username: this.username || UserModule.username,
        currentUsername: UserModule.username,
        limit: 10
      }, (lists: ListModel[]) => {
        this.lists = lists;
      });
    } else {
      ListModelUtil.getTopListsByUsername({
        username: this.username || UserModule.username,
        currentUsername: UserModule.username,
        limit: 10
      }).then(lists => {
        this.lists = lists;
      });
    }
  }

  get meta() {
    if (!this.userProfile) {
      return [];
    }

    const description = `${this.userProfile.numPublicLists} lists • ${this.userProfile.numFollowers} followers • ${this.userProfile.bio}`;
    const title = `${this.userProfile.displayName} - @${this.userProfile.username} on mixlet`;

    return [
      // OpenGraph data (Most widely used)
      // @ts-ignore
      { property: 'og:title', content: title },
      { property: 'og:site_name', content: 'mixlet' },
      // The list of types is available here: http://ogp.me/#types
      { property: 'og:type', content: 'website' },
      // Should the the same as your canonical link, see below.
      // {property: 'og:url', content: 'https://www.my-site.com/my-special-page'},
      {
        property: 'og:image',
        // @ts-ignore
        content: this.userProfile.photoURL
      },
      // Often the same as your meta description, but not always.
      // @ts-ignore
      { property: 'og:description', content: description },

      // Twitter card
      { name: 'twitter:card', content: 'summary' },
      // {
      //   name: 'twitter:site',
      //   content: 'https://www.my-site.com/my-special-page'
      // },
      // @ts-ignore
      { name: 'twitter:title', content: this.title },
      {
        name: 'twitter:description',
        // @ts-ignore
        content: description
      },
      // Your twitter handle, if you have one.
      { name: 'twitter:creator', content: '@mixlet' },
      {
        name: 'twitter:image:src',
        // @ts-ignore
        content: this.userProfile.photoURL
      },

      // Google / Schema.org markup:
      // @ts-ignore
      { itemprop: 'name', content: title },
      // @ts-ignore
      { itemprop: 'description', content: description },
      {
        itemprop: 'image',
        // @ts-ignore
        content: this.userProfile.photoURL
      }
    ];
  }

  setMetaTags() {
    const headEl = document.getElementsByTagName('head')[0];
    this.meta.forEach(metaVal => {
      const metaTag = document.createElement('meta');
      for (const key in metaVal) {
        // @ts-ignore
        metaTag.setAttribute(key, metaVal[key]);
      }
      headEl.append(metaTag);
    });
  }
}
